/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Account_ChipInputs */

const en_start_page_account_chip = /** @type {(inputs: Start_Page_Account_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 15 minutes`)
};

const pl_start_page_account_chip = /** @type {(inputs: Start_Page_Account_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Około 15 minut`)
};

/**
* | output |
* | --- |
* | "About 15 minutes" |
*
* @param {Start_Page_Account_ChipInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_account_chip = /** @type {((inputs?: Start_Page_Account_ChipInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Account_ChipInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_account_chip(inputs)
	return en_start_page_account_chip(inputs)
});